export default "__VITE_ASSET__99c9fbf2__"